import React, { forwardRef, useEffect, useRef } from "react";
import { useMediaFilesUploadInputStore } from "./MediaFilesUploadInput.store";
import { ComponentInput } from "./MediaFilesUploadInput.types";
import { useUploadPostCommentImages } from "../Modals/CommentFormModal/useUploadPostCommentImages";
import { MEDIA_TYPE } from "../Post/PostForm/PostFormModal.types";

export const MediaFilesUploadInput = forwardRef(function (
    { onUploadImage, mediaType = MEDIA_TYPE.IMAGES }: ComponentInput,
    ref,
) {
    const { images, setImages, setIsUploading } =
        useMediaFilesUploadInputStore();

    const abortController = useRef<AbortController>(new AbortController());

    const { handleOnAddImage, handleOnAddVideo } = useUploadPostCommentImages({
        images,
        setImages,
        setIsUploading,
        open: true,
        abortController: abortController.current,
        mediaType: mediaType,
    });

    useEffect(() => {
        if (useMediaFilesUploadInputStore.getState().images.length > 0) {
            onUploadImage?.();
        }
    }, [images]);

    return (
        <input
            type="file"
            multiple
            accept={
                mediaType === MEDIA_TYPE.VIDEO
                    ? "video/*"
                    : "image/*, .heic, .heif"
            }
            ref={ref}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                mediaType === MEDIA_TYPE.VIDEO
                    ? handleOnAddVideo(e)
                    : handleOnAddImage(e)
            }
            style={{
                position: "absolute",
                width: 0,
                height: 0,
                top: -9999,
                left: -9999,
            }}
        />
    );
});
